import React, { createContext, useContext, useEffect, useState } from "react";

export const THEMES = [
  { key: "timika", label: "Timika Kota", desc: "Modern civic Navy + Gold", swatch: ["#17365D", "#E5B52A"] },
  { key: "cendrawasih", label: "Cendrawasih", desc: "Gold + magenta warm", swatch: ["#A61B47", "#E5B52A"] },
  { key: "amugme", label: "Amugme", desc: "Earth tone Nemangkawi", swatch: ["#4A2B12", "#E07A2A"] },
  { key: "kamoro", label: "Kamoro", desc: "Pesisir tosca + pasir", swatch: ["#1F5F6D", "#D9C078"] },
];

const ThemeContext = createContext({ theme: "timika", setTheme: () => {} });

const STORAGE_KEY = "simpel_theme";

export function ThemeProvider({ children }) {
  const [theme, setThemeState] = useState(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      return THEMES.find(t => t.key === saved) ? saved : "timika";
    } catch { return "timika"; }
  });

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    try { localStorage.setItem(STORAGE_KEY, theme); } catch {}
  }, [theme]);

  const setTheme = (t) => setThemeState(t);

  return <ThemeContext.Provider value={{ theme, setTheme }}>{children}</ThemeContext.Provider>;
}

export function useTheme() {
  return useContext(ThemeContext);
}
